// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"817":"a71738a1","870":"1cda5bd9"}[chunkId] + ".css";
};